import React from 'react';
import { Plus, History, BadgePercent } from 'lucide-react';
import { Button } from '../../ui/button';
import { rand } from '../financeApi';
import { StatusPill } from './payShared';

export const KidPaymentRow = ({ r, role, onRecord, onFee, onHistory }) => {
  const m = r.month;
  return (
    <article className="bg-white border rounded-2xl p-4 space-y-3 min-w-0" data-testid={`pp-row-${r.kid_id}`}>
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="font-semibold truncate" data-testid={`pp-name-${r.kid_id}`}>{r.full_name}</p>
          <p className="text-xs text-muted-foreground truncate">
            {r.grade} · {r.school_name}{r.registration_number ? ` · ${r.registration_number}` : ''}{role === 'transport' && r.driver_name ? ` · ${r.driver_name}` : ''}
          </p>
        </div>
        <StatusPill status={m.status} testid={`pp-status-${r.kid_id}`} />
      </div>
      <div className="grid grid-cols-3 gap-2 text-center">
        <div className="rounded-xl bg-slate-50 p-2">
          <p className="text-[11px] text-muted-foreground">Expected</p>
          <p className="font-semibold text-sm" data-testid={`pp-expected-${r.kid_id}`}>{m.fee_set ? rand(m.expected) : '—'}</p>
          {m.special_fee && <p className="text-[10px] text-violet-700 flex items-center justify-center gap-0.5"><BadgePercent className="w-3 h-3" /> this month only</p>}
        </div>
        <div className="rounded-xl bg-emerald-50 p-2">
          <p className="text-[11px] text-muted-foreground">Received</p>
          <p className="font-semibold text-sm text-emerald-800" data-testid={`pp-received-${r.kid_id}`}>{rand(m.received)}</p>
          {m.credit_in > 0 && <p className="text-[10px] text-emerald-700">+ {rand(m.credit_in)} credit</p>}
        </div>
        <div className="rounded-xl bg-red-50 p-2">
          <p className="text-[11px] text-muted-foreground">Still owed</p>
          <p className="font-semibold text-sm text-red-700" data-testid={`pp-owed-${r.kid_id}`}>{rand(m.owed)}</p>
          {m.credit_out > 0 && <p className="text-[10px] text-emerald-700">{rand(m.credit_out)} credit to next month</p>}
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button size="sm" className="rounded-full" disabled={!r.can_record} onClick={() => onRecord(r)} data-testid={`pp-record-${r.kid_id}`}><Plus className="w-4 h-4 mr-1" /> Record payment</Button>
        <Button size="sm" variant="outline" className="rounded-full" disabled={!r.can_record} onClick={() => onFee(r)} data-testid={`pp-fee-${r.kid_id}`}>{r.normal_fee != null ? `Fee ${rand(r.normal_fee)}` : 'Set fee'}</Button>
        <Button size="sm" variant="ghost" className="rounded-full" onClick={() => onHistory(r)} data-testid={`pp-history-${r.kid_id}`}><History className="w-4 h-4 mr-1" /> History</Button>
      </div>
    </article>
  );
};
